import { render, staticRenderFns } from "./CadastrarTarefa.vue?vue&type=template&id=46047b7f&scoped=true&"
import script from "./CadastrarTarefa.vue?vue&type=script&lang=js&"
export * from "./CadastrarTarefa.vue?vue&type=script&lang=js&"
import style0 from "./CadastrarTarefa.vue?vue&type=style&index=0&id=46047b7f&scoped=true&lang=css&"
import style1 from "./CadastrarTarefa.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46047b7f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/kontalk/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VListTileAvatar } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VAutocomplete,VBtn,VCard,VCardActions,VDatePicker,VDialog,VFlex,VLayout,VListTileAvatar,VListTileContent,VListTileTitle,VMenu,VSpacer,VTextField,VTextarea})
